// extracted by mini-css-extract-plugin
export default {"flowsheetCareComponentsContainer":"FlowsheetContent_flowsheetCareComponentsContainer__Bscag","careComponentContainer":"FlowsheetContent_careComponentContainer__N6vzi"};